<div
  #pulse
  [class]="current && current.id === id ? 'pulse-container pulse-container--current' : 'pulse-container'"
>
  <div class="pulsating-circle" *ngIf="enabled && registered" (click)="displayStep()">
    <mat-icon class="pulsating-circle__icon"> help_outline </mat-icon>
  </div>
</div>
